if (!window.customElements.get('cart-gift-note')) {
  class CartGiftNote extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[name="attributes[is_gift]"]');
      this.message = this.querySelector('.cart-drawer-gift-note__message');
      this.infoButton = this.querySelector('.cart-drawer-gift-note__info');
      this.tooltip = this.querySelector('.cart-drawer-gift-note__tooltip');
      this.overlay = this.querySelector('.cart-drawer-gift-note__overlay');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.checkbox?.addEventListener('change', this.onGiftToggle, { signal });
      this.infoButton?.addEventListener('click', this.onInfoClick, { signal });
      this.infoButton?.addEventListener('mouseenter', this.onInfoHoverIn, { signal });
      this.infoButton?.addEventListener('mouseleave', this.onInfoHoverOut, { signal });
      this.infoButton?.addEventListener('focus', this.onInfoHoverIn, { signal });
      this.infoButton?.addEventListener('blur', this.onInfoHoverOut, { signal });
      document.addEventListener('click', this.onDocumentClick, { signal });
      document.addEventListener('keydown', this.onDocumentKeydown, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onGiftToggle = () => {
      const isGift = Boolean(this.checkbox?.checked);

      this.toggleAttribute('data-open', isGift);

      if (this.message) {
        this.message.hidden = !isGift;
      }

      const textarea = this.message?.querySelector('textarea[name="note"]');

      if (isGift) {
        textarea?.focus();
      } else if (textarea) {
        textarea.value = '';
      }

      this.updateGiftCart(isGift);
    };

    onInfoClick = (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (this.hasFinePointer()) return;

      this.setTooltipOpen(!this.isTooltipOpen);
    };

    onInfoHoverIn = () => {
      if (!this.hasFinePointer()) return;
      this.setTooltipOpen(true);
    };

    onInfoHoverOut = () => {
      if (!this.hasFinePointer()) return;
      this.setTooltipOpen(false);
    };

    onDocumentClick = (event) => {
      if (!this.isTooltipOpen) return;
      if (this.infoButton?.contains(event.target) || this.tooltip?.contains(event.target)) return;

      this.setTooltipOpen(false);
    };

    onDocumentKeydown = (event) => {
      if (event.key !== 'Escape' || !this.isTooltipOpen) return;

      this.setTooltipOpen(false);
      this.infoButton?.focus();
    };

    get isTooltipOpen() {
      return this.infoButton?.getAttribute('aria-expanded') === 'true';
    }

    hasFinePointer() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    setTooltipOpen(isOpen) {
      if (!this.infoButton || !this.tooltip) return;

      this.infoButton.setAttribute('aria-expanded', String(isOpen));
      this.tooltip.classList.toggle('is-open', isOpen);

      if (this.overlay) {
        this.overlay.hidden = !isOpen;
      }
    }

    updateGiftCart(isGift) {
      const payload = {
        attributes: {
          is_gift: isGift ? 'true' : ''
        }
      };

      if (!isGift) {
        payload.note = '';
      }

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    }
  }

  window.customElements.define('cart-gift-note', CartGiftNote);
}
